import Promise from 'bluebird';

export const ensureI18nSetup = () => window.webpackI18nPromise || Promise.resolve();
